/* eslint-disable */
import {
  assertNumber,
  distanceDimensionComponent,
  memoEval,
  sceneEntityObjectPropertiesComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'

export const topWithSideComponents = [
  attachComponent
    .withComponent(sceneEntityObjectPropertiesComponent, 'top', true)
    .withAlias('TopWithSide')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [
            self.$offsetY,
            self.$thicknessValue,
            self.$thicknessScaleZero,
            self.$thicknessScaleOne,
            self.side,
            self.$widthScaleZero,
            self.$widthScaleOne,
            self.$lengthScaleZero,
            self.$lengthScaleOne,
            self.$distance,
            self.$distanceScaleZero,
            self.$distanceScaleOne,
            self.$leafBevel,
            self.$leafBevelScaleZero,
            self.$leafBevelScaleOne,
            self.$bevelThickness,
            self.$bevelScaleZero,
            self.$bevelScaleOne,
          ],
        (
          $offsetY,
          $thicknessValue,
          $thicknessScaleZero,
          $thicknessScaleOne,
          side,
          $widthScaleZero,
          $widthScaleOne,
          $lengthScaleZero,
          $lengthScaleOne,
          $distance,
          $distanceScaleZero,
          $distanceScaleOne,
          $leafBevel,
          $leafBevelScaleZero,
          $leafBevelScaleOne,
          $bevelThickness,
          $bevelScaleZero,
          $bevelScaleOne
        ) => ({
          offsetY: $offsetY,
          morphTargetInfluences: {
            thickness: {
              value: $thicknessValue,
              scaleZero: $thicknessScaleZero,
              scaleOne: $thicknessScaleOne,
            },
            width: {
              value: side,
              scaleZero: $widthScaleZero,
              scaleOne: $widthScaleOne,
            },
            length: {
              value: side,
              scaleZero: $lengthScaleZero,
              scaleOne: $lengthScaleOne,
            },
            distance: {
              value: $distance,
              scaleZero: $distanceScaleZero,
              scaleOne: $distanceScaleOne,
            },
            leafBevel: {
              value: $leafBevel,
              scaleZero: $leafBevelScaleZero,
              scaleOne: $leafBevelScaleOne,
            },
            bevel: {
              value: $bevelThickness,
              scaleZero: $bevelScaleZero,
              scaleOne: $bevelScaleOne,
            },
          },
        })
      )
    ),

  attachComponent
    .withComponent(distanceDimensionComponent, 'side', true)
    .withAlias('TopWithSide')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.side, self.$minWidth, self.$maxWidth],
        (side, $minWidth, $maxWidth) => ({
          value: side,
          min: $minWidth,
          max: $maxWidth,
        })
      ),
      state => {
        assertNumber(state.value)
        return { side: state.value }
      }
    ),
]
